<template>
  <div class="home">
    <!-- <x-header :right-options="{showMore: true}" @on-click-more="showMenus = true">with more menu</x-header> -->
    <div class="container">
      <keep-alive>
        <router-view />
      </keep-alive>
    </div>
    <van-tabbar route>
      <!-- <van-tabbar-item icon="home-o" to="/home">考勤</van-tabbar-item> -->
      <!-- <van-tabbar-item
        icon="search"
        to="/notice-setting"
        v-if="getPersonType == 12"
      >
        <span>通知</span>
        <template #icon="props">
          <img :src="props.active ? icon2.active : icon2.inactive" /> </template
      ></van-tabbar-item> -->

      <van-tabbar-item icon="search" to="/approval" v-if="getPersonType == 13">
        <span>待办</span>
        <template #icon="props">
          <img :src="props.active ? icon2.active : icon2.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item icon="friends-o" to="/visitor" v-if="getPersonType == 2">
        <span>预约</span>
        <template #icon="props">
          <img :src="props.active ? icon.active : icon.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item icon="search" to="/Attendance" v-if="getPersonType != 2">
        <span>{{ getPersonType == 12 ? '校园' : '应用' }}</span>
        <template #icon="props">
          <img :src="props.active ? icon2.active : icon2.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item icon="friends-o" to="/mine">
        <span>我的</span>
        <template #icon="props">
          <img :src="props.active ? icon3.active : icon3.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menus: {
        menu1: 'Take Photo',
        menu2: 'Choose from photos',
      },
      showMenus: false,
      icon: {
        active: require('../assets/yuyue2.png'),
        inactive: require('../assets/yuyue.png'),
      },
      icon2: {
        active: require('../assets/shenpi2.png'),
        inactive: require('../assets/shenpi.png'),
      },
      icon3: {
        active: require('../assets/my2.png'),
        inactive: require('../assets/my.png'),
      },
    }
  },
  computed: {
    getPersonType() {
      return (
        localStorage.getItem('userInfo') &&
        JSON.parse(localStorage.getItem('userInfo')).personType
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  padding-bottom: 80px;
}
</style>
